import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BulmaRadioButton',
  props: {
  disabled: Boolean,
  expanded: Boolean,
  name: String,
  nativeValue: [String, Number, Boolean, Function, Object, Array],
  required: Boolean,
  size: String,
  type: {
      type: String,
      default: 'is-primary'
  },
  value: [String, Number, Boolean, Function, Object, Array]
},
  emits: ["input"],
  setup(__props, { emit: __emit }) {

/* Although meant as a replacement for Buefy RadioButton.vue,
 * this common has a simpler architecture. It does not use an input
 * element with a ref attribute for maintaining state because
 * that seemed unnecessary for encountered implementations in Rocket.
 * See SettingInput.vue for an implementation
 */
const props = __props
const emit = __emit

function handleClick() {
  emit("input", props.nativeValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["control", { 'is-expanded': __props.expanded }])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["radio button is-flex", [__props.value === __props.nativeValue ? __props.type : '', __props.size, { 
              'is-disabled': __props.disabled }]]),
      disabled: __props.disabled,
      onClick: handleClick
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_1)
  ], 2))
}
}

})